import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
import { mapDEPBResponse } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
export const ProductDEECApi = createApi({
  reducerPath: "productDEECApi",
  baseQuery,
  tagTypes: ["productDEEC"],
  endpoints: (builder) => ({
    getProductDEECTableOne: builder.query({
      query: ({ id }) => `/export/product/deec/${id}`,
      transformResponse: (response) => {
        return response?.data?.map((item,idx)=>{
          return {
            ...item,
            srNo: idx + 1,
            id: item.deecId,
          }
        }) ?? [];
      },
      providesTags: ["productDEEC"],
    }),

    createProductDEECTableOne: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/deec/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDEEC: data },
      }),
      invalidatesTags: ["productDEEC"],
    }),

    updateProductDEECTableOne: builder.mutation({
      query: ({ id,subId, ...data }) => ({
        url: `/export/product/deec/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDEEC: data },
      }),
      invalidatesTags: ["productDEEC"],
    }),

    deleteProductDEECTableOne: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/deec/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productDEEC"],
    }),
      createProductDEECTableTwo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/product/deecItem/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDEECItem: data },
      }),
      invalidatesTags: ["productDEEC"],
    }),

    updateProductDEECTableTwo: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/export/product/deecItem/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { exportProductDEECItem: data },
      }),
      invalidatesTags: ["productDEEC"],
    }),


    deleteProductDEECTableTwo: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/deecItem/${id}`,
        method: "DELETE",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
      }),
      invalidatesTags: ["productDEEC"],
    }),

    getProductDEECTableTwo: builder.query({
      query: ({ id }) => `/export/product/deecItem/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        const normalized = Array.isArray(data) ? data : [data];

        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.deecItemId,
        }));
      },
      providesTags: ["productDEEC"],
    }),
  }),
});

export const {
  useLazyGetProductDEECTableOneQuery,
  useCreateProductDEECTableOneMutation,
  useUpdateProductDEECTableOneMutation,
  useDeleteProductDEECTableOneMutation,
  useCreateProductDEECTableTwoMutation,
  useLazyGetProductDEECTableTwoQuery,
  useUpdateProductDEECTableTwoMutation,
  useDeleteProductDEECTableTwoMutation,
} = ProductDEECApi;
